import bilAPI from "../api";

export const getAcademicTerms = () => {
  return new Promise((resolve, reject) => {
    try {
      bilAPI
        .get(`/core/academic_term/`)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    } catch (error) {
      reject(error);
    }
  });
};
